<template>
  <div>
    <div class="card" v-if="nombres != ''">
      <div class="card-content">
        <button
          @click="cerrarHC()"
          class="btn btn-success btn-block btn-simple"
          style="border-radius: 5px"
        >
          <i class="fa fa-chevron-left"></i> Cerrar Historia Clínica
        </button>
      </div>
    </div>
    <div class="card" v-show="opcion == 1">
      <div class="card-header">
        <center>
          <h5 style="color: grey">
            Buscar Historia Clínica <i class="fa fa-search"></i>
          </h5>
        </center>
      </div>
      <div class="card-content">
        <form @submit.prevent="buscarPacientes()">
          <div class="row">
            <div class="col-12 col-xs-12 col-md-4">
              <br />
              <select name v-model="criterio" class="form-control">
                <option value="paciente.PacApe1">
                  <i class="fa fa-user"></i> Apellidos del paciente
                </option>
                <option value="paciente.PacNom1">Nombres del paciente</option>
                <option value="paciente.PacNumDoc">
                  Documento del paciente
                </option>
              </select>
            </div>
            <div class="col-12 col-xs-12 col-md-6">
              <br />
              <input
                required
                type="text"
                id="texto"
                name="texto"
                v-model="busqueda"
                class="form-control"
                placeholder="Buscar..."
              />
            </div>

            <div class="col-12 col-xs-12 col-md-2">
              <br />
              <button
                type="submit"
                style="border-radius: 5px"
                class="btn btn-block btn-success btn-fill"
              >
                <i class="fa fa-search"></i> Buscar
              </button>
            </div>
            <div class="col-md-1"></div>
          </div>
        </form>
      </div>
      <div class="card-content">
        <div class="table-responsive">
          <el-table
            size="mini"
            bordered
            class="table-striped"
            :data="pacientes"
          >
            <el-table-column type="index"></el-table-column>
            <el-table-column
              prop="PacNom1"
              label="Nombres"
              width="150"
            ></el-table-column>
            <el-table-column
              prop="PacApe1"
              label="Apellidos"
              width="150"
            ></el-table-column>
            <el-table-column
              prop="PacNumDoc"
              label="Documento"
              width="150"
            ></el-table-column>
            <el-table-column width="50" fixed="right">
              <template slot-scope="props">
                <a
                  class="btn btn-simple btn-icon btn-success"
                  @click="llamarPacientes(props.row)"
                >
                  <i class="fa fa-search"></i>
                </a>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div class="card" v-show="opcion != 1 && viewTab == 0">
      <div class="card-content">
        <div
          class="card"
          style="border-radius: 10px"
        >
          <div class="card-header">
            <div class="row">
              <center>
                <div class="col-12">
                  <strong class="text-grey">{{
                    nombres + " " + apellidos
                  }}</strong>
                  <br />
                  <strong style="font-size: 12px; color: red" v-if="estado == 0"
                    >INACTIVO</strong
                  >
                  <strong
                    style="font-size: 12px; color: green"
                    v-if="estado == 1"
                    >ACTIVO</strong
                  >
                  <br />
                  <strong
                    style="font-size: 12px"
                    v-if="loked != null"
                    class="text-secondary"
                    >CONFIDENCIAL</strong
                  >
                </div>
                <div class="col-sm-12">
                  <div style="width: 120px; padding-top: 5px">
                    <img
                        class="img-thumbnail"
                      style="border-radius: 15px !important"
                      :src="ip + '' + fotoPaciente"
                    />
                  </div>
                  <br />
                </div>
              </center>
              <div class="col-xs-12">
                <p class="text-grey">Información del paciente:</p>
              </div>
              <div class="col-xs-12">
                <p>
                  <i class="fa fa-calendar"></i>
                  <small class="text-grey">F. de ingreso:</small>
                  <small
                    ><strong>{{ fechaIngreso | date }}</strong></small
                  >
                </p>
              </div>
              <div class="col-xs-12">
                <p>
                  <i class="fa fa-calendar"></i>
                  <small class="text-grey">F. de nacimiento:</small>
                  <small
                    ><strong>{{ Fecha_nacimiento | date }}</strong></small
                  >
                </p>
              </div>
              <div class="col-xs-12">
                <p>
                  <i class="fa fa-calendar"></i>
                  <small class="text-grey">Edad</small>
                  <small
                    ><strong>{{ anos }} años y {{ meses }} meses</strong></small
                  >
                </p>
              </div>
              <div class="col-xs-12">
                <p>
                  <i class="fa fa-male"></i>
                  <small class="text-grey">Sexo:</small>
                  <small
                    ><strong>{{ sexo }}</strong></small
                  >
                </p>
              </div>
              <div class="col-xs-12">
                <p class="text-grey">Datos de afiliación:</p>
              </div>
              <div class="col-xs-4">
                <small>EPS:</small> <br />
                <strong>{{ eps }}</strong>
              </div>
              <div class="col-xs-4">
                <small>Prepagada:</small> <br />
                <strong>{{ prepagada }}</strong>
              </div>
              <div class="col-xs-4">
                <small>Póliza:</small> <br />
                <strong>{{ poliza }}</strong>
              </div>
              <div class="col-xs-6">
                <small>Tipo de afiliación:</small> <br />
                <strong>{{ tipoAfiliacion }}</strong>
              </div>
            </div>
            <div
              class="row"
              v-if="
                loked == usuarioAvanza ||
                loked == null ||
                rol == 1 ||
                rol == 9 ||
                rol == 13
              "
            >
              <br />
              <div class="col-xs-12" v-for="card in cards_tab" :key="card.tab">
                <div class="card" style="background-color: #efefef; border-radius: 5px">
                  <div class="card-content">
                    <div class="row">
                      <div class="col-xs-2">
                        <i
                          class="fa fa-file text-grey"
                          style="font-size: 30px"
                        ></i>
                      </div>
                      <div class="col-xs-7">
                        <strong>{{ card.title }}</strong>
                      </div>
                      <div class="col-xs-2">
                        <button
                          @click="viewTabFunction(card.tab)"
                          class="btn btn-primary btn-simple"
                        >
                          <i class="fa fa-chevron-right"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-else>
              <div class="col-xs-12">
                <center>
                  <br />
                  <br />
                  <img
                    src="static/img/ICONOS/candado.svg"
                    class="img-responsive"
                    style="width: 120px"
                    alt="Imagen de bloqueo de HC avanti"
                  />
                  <br />
                  <span
                    >Esta HC es confidencial. Por favor comunicarse con el
                    administrador para solicitar acceso.</span
                  >
                </center>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card" v-if="opcion != 1 && viewTab == 1">
      <div class="card-header">
        <div class="row">
          <div class="col-12">
            <button
              @click="viewTabFunction(0)"
              class="btn btn-primary btn-simple"
            >
              <i class="fa fa-chevron-left"></i> Volver
            </button>
          </div>
          <center>
            <div class="col-12">
              <strong class="text-grey">{{ nombres + " " + apellidos }}</strong>
              <br />
              <strong style="font-size: 12px; color: red" v-if="estado == 0"
                >INACTIVO</strong
              >
              <strong style="font-size: 12px; color: green" v-if="estado == 1"
                >ACTIVO</strong
              >
              <br />
              <strong
                style="font-size: 12px"
                v-if="loked != null"
                class="text-secondary"
                >CONFIDENCIAL</strong
              >
            </div>
          </center>
        </div>
      </div>
      <div class="card-content">
        <div class="row">
          <center>
            <strong class="text-grey">Motivo de consulta verificado</strong>
            <br />
            <small
              >Total motivos de consulta: ( {{ arrayMotivo.length }} )</small
            >
          </center>
        </div>
        <div class="row" style="padding: 5px">
          <div class="table-responsive" style="border: none">
            <el-table
              class="table-striped table-sm"
              size="mini"
              :data="arrayMotivo"
              v-if="arrayMotivo != ''"
            >
              <el-table-column label="#" type="index"></el-table-column>
              <el-table-column label="Fecha" width="140">
                <template slot-scope="props">{{ props.row.MotFec }}</template>
              </el-table-column>
              <el-table-column
                width="250"
                prop="MotDes"
                label="Motivo de consulta"
              ></el-table-column>
              <el-table-column
                prop="MotTer"
                width="135"
                label="Terapeuta"
              ></el-table-column>
              <el-table-column label="Estado" width="135" fixed="right">
                <template slot-scope="props">
                  <div v-if="props.row.MotEst == 0">
                    <span
                      style="border-radius: 5px"
                      slot="title-label"
                      class="label label-warning"
                    >
                      <i class="ti-close"></i> Por verificar
                    </span>
                  </div>
                  <div v-if="props.row.MotEst == 1">
                    <span
                      style="border-radius: 5px"
                      slot="title-label"
                      class="label label-success"
                    >
                      <i class="fa fa-check"></i> Verificado
                    </span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <div class="card" v-if="opcion != 1 && viewTab == 2">
      <div class="card-header">
        <div class="row">
          <div class="col-12">
            <button
              @click="viewTabFunction(0)"
              class="btn btn-primary btn-simple"
            >
              <i class="fa fa-chevron-left"></i> Volver
            </button>
          </div>
          <center>
            <div class="col-12">
              <strong class="text-grey">{{ nombres + " " + apellidos }}</strong>
              <br />
              <strong style="font-size: 12px; color: red" v-if="estado == 0"
                >INACTIVO</strong
              >
              <strong style="font-size: 12px; color: green" v-if="estado == 1"
                >ACTIVO</strong
              >
              <br />
              <strong
                style="font-size: 12px"
                v-if="loked != null"
                class="text-secondary"
                >CONFIDENCIAL</strong
              >
            </div>
          </center>
        </div>
      </div>
      <div class="card-content">
        <div class="row">
          <center>
            <strong class="text-grey">Antecedentes</strong> <br />
          </center>
        </div>
        <div class="row">
          <vue-tabs direction="horizontal" value="l">
            <v-tab
              :title="
                'Prenatales' + '  ' + '( ' + antecedentesPre.length + ' )'
              "
            >
              <div class="table-responsive">
                <el-table
                  class="table-striped"
                  size="mini"
                  :data="antecedentesPre"
                  v-if="antecedentesPre != ''"
                >
                  <el-table-column label="#" type="index"></el-table-column>
                  <el-table-column
                    prop="AntDes"
                    label="Descripción"
                  ></el-table-column>

                  <el-table-column
                    prop="terapeuta"
                    label="Terapeuta"
                    width="185"
                  ></el-table-column>
                </el-table>
              </div>
            </v-tab>
            <v-tab
              :title="'Neonatales' + ' ' + '( ' + antecedentesNeo.length + ' )'"
            >
              <div class="table-responsive">
                <el-table
                  class="table-striped"
                  size="mini"
                  :data="antecedentesNeo"
                >
                  <el-table-column label="#" type="index"></el-table-column>
                  <el-table-column
                    prop="AntDes"
                    label="Descripción"
                  ></el-table-column>

                  <el-table-column
                    prop="terapeuta"
                    label="Terapeuta"
                    width="185"
                  ></el-table-column>
                </el-table>
              </div>
            </v-tab>
            <v-tab :title="'Postnatales ( ' + antecedentesPos.length + ' )'">
              <div class="table-responsive">
                <el-table
                  class="table-striped"
                  size="mini"
                  :data="antecedentesPos"
                >
                  <el-table-column label="#" type="index"></el-table-column>
                  <el-table-column
                    prop="AntDes"
                    label="Descripción"
                  ></el-table-column>

                  <el-table-column
                    prop="terapeuta"
                    label="Terapeuta"
                    width="185"
                  ></el-table-column>
                </el-table>
              </div>
            </v-tab>
            <v-tab :title="'Personales ( ' + antecedentesPer.length + ' )'">
              <div class="table-responsive">
                <el-table
                  class="table-striped"
                  size="mini"
                  :data="antecedentesPer"
                >
                  <el-table-column label="#" type="index"></el-table-column>
                  <el-table-column
                    prop="AntDes"
                    label="Descripción"
                  ></el-table-column>

                  <el-table-column
                    prop="terapeuta"
                    label="Terapeuta"
                    width="185"
                  ></el-table-column>
                </el-table>
              </div>
            </v-tab>
            <v-tab :title="'Familiares ( ' + antecedentesFam.length + ' )'">
              <div class="table-responsive">
                <el-table
                  class="table-striped table-sm"
                  size="mini"
                  :data="antecedentesFam"
                >
                  <el-table-column label="#" type="index"></el-table-column>
                  <el-table-column
                    prop="AntDes"
                    label="Descripción"
                  ></el-table-column>
                  <el-table-column
                    prop="terapeuta"
                    label="Terapeuta"
                    width="185"
                  ></el-table-column>
                </el-table>
              </div>
            </v-tab>
          </vue-tabs>
        </div>
      </div>
    </div>
    <div class="card" v-if="opcion != 1 && viewTab == 3">
      <div class="card-header">
        <div class="row">
          <div class="col-12">
            <button
              @click="viewTabFunction(0)"
              class="btn btn-primary btn-simple"
            >
              <i class="fa fa-chevron-left"></i> Volver
            </button>
          </div>
          <center>
            <div class="col-12">
              <strong class="text-grey">{{ nombres + " " + apellidos }}</strong>
              <br />
              <strong style="font-size: 12px; color: red" v-if="estado == 0"
                >INACTIVO</strong
              >
              <strong style="font-size: 12px; color: green" v-if="estado == 1"
                >ACTIVO</strong
              >
              <br />
              <strong
                style="font-size: 12px"
                v-if="loked != null"
                class="text-secondary"
                >CONFIDENCIAL</strong
              >
            </div>
          </center>
        </div>
      </div>
      <div class="card-content">
        <div class="row">
          <center>
            <strong class="text-grey">Impresión General</strong> <br />
            <small>Total de observaciones ( {{ arrayResumen.length }} )</small>
          </center>
        </div>
        <div class="row">
          <div class="table-responsive">
            <el-table class="table-striped" size="mini" :data="arrayResumen">
              <el-table-column
                label="#"
                width="70"
                type="index"
              ></el-table-column>
              <el-table-column label="Fecha" width="120">
                <template slot-scope="props">
                  {{ props.row.ResFec }}
                </template>
              </el-table-column>
              <el-table-column
                prop="terapeuta"
                label="Terapeuta"
                width="120"
              ></el-table-column>
              <el-table-column
                width="350"
                prop="ResDes"
                label="Descripción"
              ></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <div class="card" v-if="opcion != 1 && viewTab == 4">
      <div class="card-header">
        <div class="row">
          <div class="col-12">
            <button
              @click="viewTabFunction(0)"
              class="btn btn-primary btn-simple"
            >
              <i class="fa fa-chevron-left"></i> Volver
            </button>
          </div>
          <center>
            <div class="col-12">
              <strong class="text-grey">{{ nombres + " " + apellidos }}</strong>
              <br />
              <strong style="font-size: 12px; color: red" v-if="estado == 0"
                >INACTIVO</strong
              >
              <strong style="font-size: 12px; color: green" v-if="estado == 1"
                >ACTIVO</strong
              >
              <br />
              <strong
                style="font-size: 12px"
                v-if="loked != null"
                class="text-secondary"
                >CONFIDENCIAL</strong
              >
            </div>
          </center>
        </div>
      </div>
      <div class="card-content">
        <div class="row">
          <center>
            <strong class="text-grey">Examen Paciente</strong> <br />
          </center>
        </div>
        <div class="row">
          <center>
            <strong style="color: grey; font-size: 18px">
              <i class="fa fa-filter"></i> Seleccione el exámen
            </strong>
          </center>
          <br />
          <div class="col-md-3"></div>
          <div class="col-md-6">
            <select
              @change="tipoExamen()"
              v-model="examen"
              class="form-control"
            >
              <option value="0">Seleccionar...</option>
              <option value="1">
                Formato de evaluación de terapia ocupacional (AVANZA)
              </option>
              <option value="2">Formato de evaluación psicología niños</option>
              <option value="3">
                Formato de evaluación fonoaudiólogia función oral faringea
              </option>
              <option value="4">
                Formato de evaluación fonoaudiólogia lenguaje
              </option>
              <option value="5">
                Examen fisico basado en neurodesarrollo (AVANZA)
              </option>
              <option value="6">
                Evaluación de la desorganización postural
              </option>
              <option value="7">
                Formato de evaluación musculoesquelética
              </option>
              <option value="8">Psicología adulto</option>
              <option value="9">Evaluación cognitiva</option>
              <option value="10">Evaluación comportamental</option>
              <option value="11">Revisión por sistemas</option>
            </select>
          </div>

          <div>
            <div class="" v-if="examen != 0">
              <div class="table-responsive" style="border: none">
                <center>
                  <el-table
                    class="table-striped"
                    size="mini"
                    v-if="examen != 0"
                    :data="arrayActivo"
                  >
                    <el-table-column type="index"></el-table-column>
                    <el-table-column prop="created_at" label="Fecha y Hora">
                      <template slot-scope="props">
                        <div>{{ props.row.created_at | dateC }}</div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="terapeuta"
                      label="Terapeuta"
                    ></el-table-column>
                  </el-table>
                </center>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card" v-if="opcion != 1 && viewTab == 5">
      <div class="card-header">
        <div class="row">
          <div class="col-12">
            <button
              @click="viewTabFunction(0)"
              class="btn btn-primary btn-simple"
            >
              <i class="fa fa-chevron-left"></i> Volver
            </button>
          </div>
          <center>
            <div class="col-12">
              <strong class="text-grey">{{ nombres + " " + apellidos }}</strong>
              <br />
              <strong style="font-size: 12px; color: red" v-if="estado == 0"
                >INACTIVO</strong
              >
              <strong style="font-size: 12px; color: green" v-if="estado == 1"
                >ACTIVO</strong
              >
              <br />
              <strong
                style="font-size: 12px"
                v-if="loked != null"
                class="text-secondary"
                >CONFIDENCIAL</strong
              >
            </div>
          </center>
        </div>
      </div>
      <div class="card-content">
        <div class="row">
          <center>
            <strong class="text-grey"
              >Conclusiones, recomendación y plan de tratamiento</strong
            >
            <br />
            <small>Total tratamientos: ( {{ tratamiento.length }} )</small>
          </center>
        </div>
        <div class="row">
          <div class="table-responsive">
            <el-table class="table-striped table-sm" :data="tratamiento">
              <el-table-column label="#" type="index"></el-table-column>
              <el-table-column label="Fecha inicial" width="100">
                <template slot-scope="props">{{ props.row.TraFec }}</template>
              </el-table-column>
              <el-table-column label="Fecha Fin" width="100">
                <template slot-scope="props">
                  <p v-if="props.row.TraFecFin == null">Indefinido</p>
                  <p v-else>{{ props.row.TraFecFin }}</p>
                </template>
              </el-table-column>
              <el-table-column
                prop="terapeuta"
                label="Terapeuta"
                width="130"
              ></el-table-column>
              <el-table-column
                width="300"
                prop="TraDes"
                label="Observaciones"
              ></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <div class="card" v-if="opcion != 1 && viewTab == 6">
      <div class="card-header">
        <div class="row">
          <div class="col-12">
            <button
              @click="viewTabFunction(0)"
              class="btn btn-primary btn-simple"
            >
              <i class="fa fa-chevron-left"></i> Volver
            </button>
          </div>
          <center>
            <div class="col-12">
              <strong class="text-grey">{{ nombres + " " + apellidos }}</strong>
              <br />
              <strong style="font-size: 12px; color: red" v-if="estado == 0"
                >INACTIVO</strong
              >
              <strong style="font-size: 12px; color: green" v-if="estado == 1"
                >ACTIVO</strong
              >
              <br />
              <strong
                style="font-size: 12px"
                v-if="loked != null"
                class="text-secondary"
                >CONFIDENCIAL</strong
              >
            </div>
          </center>
        </div>
      </div>
      <div class="card-content">
        <div class="row">
          <center>
            <strong class="text-grey">Plan de intervención terapéutica</strong>
            <br />
            <small>Total tratamientos: ( {{ evoluciones.length }} )</small>
          </center>
        </div>
        <div class="row">
          <div class="table-responsive">
            <el-table
              class="table-striped"
              size="mini"
              max-height="500"
              :data="evoluciones"
            >
              <!-- <el-table-column label="Id" property="id"></el-table-column> -->
              <el-table-column label="#" type="index"></el-table-column>
              <el-table-column
                label="Fecha"
                width="100"
                prop="EvoFec"
              ></el-table-column>
              <el-table-column
                label="Terapeuta"
                prop="EvoTer"
                width="110"
              ></el-table-column>
              <el-table-column
                label="Evolución"
                width="400"
                prop="Obs"
              ></el-table-column>
              <el-table-column width="170" label="Est. terapéutica">
                <template slot-scope="props">
                  <p
                    style="font-size: 12px"
                    v-if="
                      props.row.Obs == 'Se hizo una evaluación del paciente'
                    "
                  >
                    Evaluación
                  </p>
                  <p v-else style="font-size: 12px">
                    {{ props.row.EvoEst }}
                  </p>
                </template></el-table-column
              >
              <el-table-column label="Mat. de apoyo" width="170">
                <template slot-scope="props">
                  <p
                    style="font-size: 12px"
                    v-if="
                      props.row.Obs == 'Se hizo una evaluación del paciente'
                    "
                  ></p>
                  <p v-else style="font-size: 12px">
                    {{ props.row.EvoMat }}
                  </p>
                </template></el-table-column
              >
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import { Table, TableColumn, Select, Option } from "element-ui";
import { Collapse, CollapseItem } from "element-ui";
import VueTabs from "vue-nav-tabs";
import VModal from "vue-js-modal";

import { jsPDF } from "jspdf";
import "jspdf-autotable";

Vue.use(VModal);
Vue.use(VueTabs);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Table);
Vue.use(Select);
Vue.use(TableColumn);
export default {
  data() {
    return {
      viewTab: 0,
      dxeditId: "",
      dxedit: [],
      usuarioAvanza: "",
      motivosConsulta: "",
      optionsArray: [],
      tmconsulta: [],
      informacion: "",
      pacientes: [],
      arrayMotivo: [], //NOMBRE DEL ARRAY EN EL QUE VAS A ALMACENAR LOS DATOS
      //POR EJEMPLO pacientes: [] solo aquí es donde lo declaras
      criterio: "paciente.PacApe1",
      busqueda: "",
      anos: 0,
      meses: 0,
      multiple: "ARS",

      // datos paciente
      numeroDocumento: "",
      apellidos: "",
      nombres: "",
      fechaIngreso: "",
      Fecha_nacimiento: "",
      sexo: "",
      eps: "",
      poliza: "",
      tipoAfiliacion: '',
      prepagada: "",
      regimen: 1,
      PacIde: "",
      loked: true,
      numeroDocumentoBuscar: "",
      fotoPaciente: "",
      estado: 0,
      rol: localStorage.getItem("rol"),

      // consulta
      motivoDeConsulta: "",
      fechaDeConsulta: "",
      fechaVerificado: "",
      motivoVerificarIde: "",
      motivoVerificarFec: "",
      motivoVerificarDes: "",
      consultaVerificada: "",
      contador_motivos: 0,
      evoluciones: [],
      // array Motivo

      // array impresion
      arrayImpresion: [],

      // antecedente
      tipoAntecedente: 1,
      antecedenteActivo: "",
      fechaAntecedente: "",

      descripcionAntecedente: "",
      antecedentesPre: [],
      contador_pre: 0,
      antecedentesNeo: [],
      antecedentesPos: [],
      antecedentesPer: [],
      antecedentesFam: [],
      fotoBASE: "",

      // impresion
      // fechaImpresion : '',

      // resumen

      fechaResumen: "",
      descripcionResumen: "",
      arrayResumen: [],
      descripcionImpresion: "",
      impresionDiagnostica: "",
      conclusiones: "",
      arrayAntecedente: [],
      arrayCie10: [],
      arrayDsm4: [],
      cie10: [],
      dsm4: [],
      conclusiones: "",
      detalleResumenFecha: "",
      detalleDescripcionResumen: "",
      detalleConclusionResumen: "",
      detalleCie10: [],
      detalleDsm4: [],

      // plan tratamiento

      fechaTratamiento: "",
      descripcionTratamiento: "",
      arrayTratamiento: "",
      arrayEspecialidad: [],
      arrayEspecialidades: [],
      especialidad: "",
      sesiones: "",
      arrayDetalle: [],
      fechaFinTratamiento: "",
      actividadFamiliar: "",
      trabajoFamiliar: "",

      // examen

      examen: 0,
      verificacion: false,
      mostrarCie10: true,
      mostrarDsm4: true,
      opcion: 1,

      //Examenes
      arrayExamen: [],
      arrayExamen2: [],
      arrayExamen3: [],
      arrayExamen4: [],
      arrayExamen5: [],
      arrayExamen6: [],
      arrayExamen7: [],
      arrayExamen8: [],
      arrayExamen9: [],
      arrayExamen10: [],
      arrayExamen11: [],
      examenActivo: 1,
      arrayActivo: [],
      examenEnviar: "",
      nombreExamen: "",
      links_examen: [
        "NULL",
        "https://drive.google.com/file/d/1QQvTRCVPfbgasJ-agXYymsFzCSOsIEtp/view?usp=sharing",
        "https://drive.google.com/file/d/1nZTTxOPpTy_RYbcqFcClm6wEKMqsM2yx/view?usp=sharing",
        "https://drive.google.com/file/d/1AKYS5wSOs8cCh0fVc4cE3Tc32GcAvhrG/view",
        "https://drive.google.com/file/d/1um4R2ymKd_gdww2WPBsdwzmS1dHoQf5R/view",
        "https://drive.google.com/file/d/1y9pVcX8QR55yyxtzmjsELkNB-FpQMeXA/view?usp=sharing",
        "https://drive.google.com/open?id=1uHrljOme7yU-7Ssok1mr1A3ajGsUC_lD",
        "https://drive.google.com/open?id=1d5K0en09ws3umkRoXZF5UC548tTmhDnB",
        "https://drive.google.com/file/d/17EaZD7K4bddoVmuTIm9kpqMhsZ4kVKww/view",
        "https://drive.google.com/open?id=1-WrHRmIMCbXO-dq3MuwuaUHbTRf8knM0",
        "https://drive.google.com/open?id=1tzemT8CBzdUW5E9I8449NjlGP-2hma03",
        "https://drive.google.com/file/d/0B54PTJg2YNL-TVFvbnpTc3laZGc/view?resourcekey=0-QCwexOdYyxlTsC5V9hT7Cw",
      ],
      link_examen_selecte: "",
      // tratamiento
      tratamiento: [],
      // pdf

      cards_tab: [
        {
          tab: 1,
          title: "MOTIVO DE CONSULTA VERIFICADO",
        },
        {
          tab: 2,
          title: "ANTECEDENTES",
        },
        {
          tab: 3,
          title: "IMPRESIÓN GENERAL",
        },
        {
          tab: 4,
          title: "EXAMEN PACIENTE",
        },
        {
          tab: 5,
          title: "CONCLUSIONES, RECOMENDACIÓN Y PLAN DE TTO",
        },
        {
          tab: 6,
          title: "PLAN INTERVENCIÓN TERAPÉUTICA",
        },
      ],

      // notificaciones
      type: ["", "info", "success", "warning", "danger"],
      notifications: {
        topCenter: false,
      },
      ip: "https://avanti-erp.com/",
      mensaje: "No hay datos de pacientes",
      icono: "bell",
      examenesRealizados: [],
      examenesRealizadosPs: [],
      examenesRealizadosfonol: [],
      indefinido: false,
      periodoPT: 1,
      motivoConsultaHoy: false,
      antecedenteHoy: false,
      impresionHoy: false,
      examenHoy: false,
      tratamientoHoy: false,
      e_motivo: true,
      e_antecedente: true,
      e_resumen: true,
      e_tratamiento: true,
      cie10mostrar: "",
      logo: "",
      terapeutaPDF: "",
      recomendacionPDF: "",
    };
  },
  methods: {
    viewTabFunction: function (tab) {
      this.viewTab = tab;
      window.scroll(0, 0);
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      return this.$validator.validateAll();
    },
    cerrarHC() {
      localStorage.removeItem("PacienteHC");
      localStorage.removeItem("PacienteId");

      location.reload();
    },
    cambiarLinkExamen: function () {
      this.link_examen_selecte = this.links_examen[this.examen];
    },
    motivos() {
      var token = localStorage.getItem("token");
      axios
        .request({
          method: "get",
          baseURL: this.ip + "api/motivos/" + this.PacIde,
          headers: {
            Authorization: "Bearer " + token, //utilizacion de la variable que contiene el token
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.arrayMotivo = response.data.data;
          // console.log(this.arrayMotivo);
          this.contador_motivos = this.arrayMotivo.length;
          if (response.data.data.length > 0) {
            this.motivoConsultaHoy = true;
          }

          this.validarMotivosVerificados(response.data.data);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    validarMotivosVerificados(motivos) {
      for (let index = 0; index < motivos.length; index++) {
        if (motivos[index].MotEst != 1) {
          this.motivoConsultaHoy = false;
        }
        // console.log(motivos[index]);
      }
    },
    motivosM() {
      this.optionsArray = [];
      var token = localStorage.getItem("token");
      axios
        .request({
          method: "get",
          baseURL: this.ip + "api/motivos",
          headers: {
            Authorization: "Bearer " + token, //utilizacion de la variable que contiene el token
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.optionsArray = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    motivoVerificar(row, option = 1) {
      this.verificacion = row.MotEst;
      if (this.verificacion == 0 && option == 1) {
        this.$modal.show("modalVerificarMC");
      }
      if (this.verificacion != 0 && option == 1) {
        this.$modal.show("modalDetallesMC");
      }
      this.tmconsulta = [];
      this.motivoVerificarIde = row.MotIde;
      this.motivoVerificarFec = row.MotFec;
      this.motivoVerificarDes = row.MotDes;
      this.consultaVerificada = row.MotVer;
      var token = localStorage.getItem("token");
      // let dateDB = [];
      axios
        .request({
          method: "get",
          baseURL: this.ip + "api/completo/" + this.motivoVerificarIde,
          headers: {
            Authorization: "Bearer " + token, //utilizacion de la variable que contiene el token
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          let datos = response.data.data.length;
          for (let i = 0; i < datos; ) {
            this.tmconsulta.push(response.data.data[i].VerDes);
            i++;
          }

          if (option == 1) {
            this.motivos();
          }
        })

        .catch(function (error) {
          console.log(error);
        });

      // console.log(motivo);
    },

    llamarPacientes(row) {
      let respuesta = "";
      this.numeroDocumentoBuscar = row.PacNumDoc;
      if (this.numeroDocumentoBuscar != "") {
        var buscar = this.numeroDocumentoBuscar;
        var token = localStorage.getItem("token");
        axios
          .request({
            method: "get",
            baseURL: this.ip + "api/pacienteHC/" + row.PacIdeUsu,
            headers: {
              Authorization: "Bearer " + token, //utilizacion de la variable que contiene el token
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            if (response.data.data == 0) {
              alert("No se encontraron datos");
            } else {
              this.PacIde = row.PacIdeUsu;
              this.numeroDocumento = response.data.data.datos[0].PacNumDoc;
              localStorage.setItem(
                "PacienteHC",
                response.data.data.datos[0].PacNumDoc
              );
              localStorage.setItem("PacienteId", row.PacIdeUsu);
              localStorage.setItem(
                "PacienteNombre",
                response.data.data.datos[0].PacNom1 +
                  " " +
                  response.data.data.datos[0].PacApe1
              );
              this.nombres = response.data.data.datos[0].PacNom1;
              this.apellidos = response.data.data.datos[0].PacApe1;
              this.fotoPaciente = response.data.data.datos[0].url_foto;
              if (response.data.data.datos[0].PacSex == 1) {
                this.sexo = "Masculino";
              } else {
                this.sexo = "Femenino";
              }
              this.Fecha_nacimiento = response.data.data.datos[0].PacFecNac;
              this.fechaIngreso = response.data.data.datos[0].PacFecIng;
              this.eps = response.data.data.eps;
              this.tipoAfiliacion = response.data.data.datos[0].TipCliNom;
              this.prepagada = response.data.data.prepagada;
              this.poliza = response.data.data.poliza;
              if (response.data.data.datos[0].PacReg == 1) {
                this.regimen = "Contributivo";
              } else {
                this.regimen = "Subsidiado";
              }

              this.estado = response.data.data.datos[0].estado;
              this.loked = response.data.data.datos[0].PacBlo;

              this.fotoBASE = response.data.data.datos[0].url_fotoBS;

              this.motivos();
              this.resumen();
              this.examenes();
              this.antecedentes();
              this.tratamientos();
              this.e_realizados_to();
              this.e_realizados_ps();
              this.e_realizados_fonol();
              this.calcularEdad();
              this.getEvoluciones(row.PacIdeUsu);
              this.motivoConsultaHoy = false;
              this.antecedenteHoy = false;
              this.impresionHoy = false;
              this.examenHoy = false;
              this.tratamientoHoy = false;
              this.e_motivo = true;
              this.opcion = 2;
              this.e_antecedente = true;
              this.e_resumen = true;
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },

    buscarPacientes() {
      this.mensaje = "Cargando...";
      this.icono = "spinner";
      this.pacientes = [];
      var token = localStorage.getItem("token");
      axios
        .request({
          method: "get",
          baseURL:
            this.ip + "api/pacientesHC/" + this.criterio + "/" + this.busqueda,
          headers: {
            Authorization: "Bearer " + token, //utilizacion de la variable que contiene el token
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.icono = "bell";
          this.mensaje = "No hay datos de pacientes";
          this.pacientes = response.data.data;
          if (localStorage.getItem("PacienteHC")) {
            this.llamarPacientes(response.data.data[0]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    cie10M() {
      var token = localStorage.getItem("token");
      axios
        .request({
          method: "get",
          baseURL: this.ip + "api/cie10",
          headers: {
            Authorization: "Bearer " + token, //utilizacion de la variable que contiene el token
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          var datos = response.data.data.length;
          if (response.data.data != "") {
            for (let i = 0; i < datos; ) {
              this.arrayCie10.push(response.data.data[i]);
              // console.log(this.arrayCie10);
              i++;
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    dsm4M() {
      var token = localStorage.getItem("token");
      axios
        .request({
          method: "get",
          baseURL: this.ip + "api/dsm4",
          headers: {
            Authorization: "Bearer " + token, //utilizacion de la variable que contiene el token
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          var datos = response.data.data.length;
          if (response.data.data != "") {
            for (let i = 0; i < datos; ) {
              this.arrayDsm4.push(response.data.data[i]);
              i++;
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getEvoluciones: function (paciente) {
      const BASE_URL = `${this.ip}api/evoluciones/${paciente}`;
      let config = {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };
      axios
        .request({
          method: "get",
          baseURL: BASE_URL,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"), //utilizacion de la variable que contiene el token
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          let evoluciones = [];
          // console.log('evoluciones', res.data);
          // this.evoluciones = res.data.data;
          for (let i = 0; i < res.data.data.length; i++) {
            evoluciones.push({
              EvoTer:
                res.data.data[i].nombres + " " + res.data.data[i].apellidos,
              Obs: res.data.data[i].Obs,
              EvoMat: res.data.data[i].EvoMat,
              EvoFec: res.data.data[i].EvoFec,
              EvoEst: res.data.data[i].EvoEst,
            });
          }
          this.evoluciones = evoluciones;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    antecedentes() {
      var token = localStorage.getItem("token");
      axios
        .request({
          method: "get",
          baseURL: this.ip + "api/antecedentes/" + this.PacIde,
          headers: {
            Authorization: "Bearer " + token, //utilizacion de la variable que contiene el token
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.antecedentesPre = response.data.data.pre;
          if (response.data.data.pre.length > 0) {
            this.antecedenteHoy = true;
          }
          this.contador_pre = response.data.data.pre.length;
          this.antecedentesNeo = response.data.data.neo;
          if (response.data.data.neo.length > 0) {
            this.antecedenteHoy = true;
          }
          this.antecedentesPos = response.data.data.pos;
          if (response.data.data.pos.length > 0) {
            this.antecedenteHoy = true;
          }
          this.antecedentesPer = response.data.data.per;
          if (response.data.data.per.length > 0) {
            this.antecedenteHoy = true;
          }
          this.antecedentesFam = response.data.data.fam;
          if (response.data.data.fam.length > 0) {
            this.antecedenteHoy = true;
          }
          this.cambiarTipoAntecedente();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    cambiarTipoAntecedente() {
      if (this.tipoAntecedente == "1") {
        this.antecedenteActivo = "Prenatales";
        this.arrayAntecedente = this.antecedentesPre;
      }
      if (this.tipoAntecedente == 2) {
        this.antecedenteActivo = "Neonatales";
        this.arrayAntecedente = this.antecedentesNeo;
      }
      if (this.tipoAntecedente == 3) {
        this.antecedenteActivo = "Postnatales";
        this.arrayAntecedente = this.antecedentesPos;
      }
      if (this.tipoAntecedente == 4) {
        this.antecedenteActivo = "Personales";
        this.arrayAntecedente = this.antecedentesPer;
      }
      if (this.tipoAntecedente == 5) {
        this.antecedenteActivo = "Familiares";
        this.arrayAntecedente = this.antecedentesFam;
      }
    },

    resumen() {
      var token = localStorage.getItem("token");
      axios
        .request({
          method: "get",
          baseURL: this.ip + "api/resumen/" + this.PacIde,
          headers: {
            Authorization: "Bearer " + token, //utilizacion de la variable que contiene el token
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.cie10M();
          this.dsm4M();
          this.arrayResumen = response.data.data;
          if (response.data.data.length > 0) {
            this.impresionHoy = true;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    detalleResumen(row) {
      var token = localStorage.getItem("token");
      this.detalleResumenFecha = row.ResFec;
      this.detalleDescripcionResumen = row.ResDes;
      this.detalleConclusionResumen = row.ResCon;
      this.$modal.show("modalDetalleAnamnesis");
      this.detalleDsm4 = [];
      this.detalleCie10 = [];

      axios
        .request({
          method: "get",
          baseURL: this.ip + "api/detalleResumen/" + row.ResIde,
          headers: {
            Authorization: "Bearer " + token, //utilizacion de la variable que contiene el token
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          for (let i = 0; i < response.data.data.cie10.length; i++) {
            this.detalleCie10.push(response.data.data.cie10[i].DetDes);
          }
          for (let i = 0; i < response.data.data.dsm4.length; i++) {
            this.detalleDsm4.push(response.data.data.dsm4[i].DetDes);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    examenes() {
      var token = localStorage.getItem("token");
      axios
        .request({
          method: "get",
          baseURL: this.ip + "api/examenes/" + this.PacIde,
          headers: {
            Authorization: "Bearer " + token, //utilizacion de la variable que contiene el token
            "Content-Type": "application/json",
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.arrayExamen = response.data.data.examenes1;
          this.arrayExamen2 = response.data.data.examenes2;
          this.arrayExamen3 = response.data.data.examenes3;
          this.arrayExamen4 = response.data.data.examenes4;
          this.arrayExamen5 = response.data.data.examenes5;
          this.arrayExamen6 = response.data.data.examenes6;
          this.arrayExamen7 = response.data.data.examenes7;
          this.arrayExamen8 = response.data.data.examenes8;
          this.arrayExamen9 = response.data.data.examenes9;
          this.arrayExamen10 = response.data.data.examenes10;
          this.arrayExamen11 = response.data.data.examenes11;
          for (let index = 1; index < 11; index++) {
            if (response.data.data["examenes" + index].length > 0) {
              this.examenHoy = true;
            }
          }
          this.tipoExamen();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    tratamientos() {
      var token = localStorage.getItem("token");
      axios
        .request({
          method: "get",
          baseURL: this.ip + "api/tratamientos/" + this.PacIde,
          headers: {
            Authorization: "Bearer " + token, //utilizacion de la variable que contiene el token
            "Content-Type": "application/json",
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.tratamiento = response.data.data;
          if (response.data.data.length > 0) {
            this.tratamientoHoy = true;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    nuevaEspecialidad() {
      if (this.especialidad != "" && this.sesiones != "") {
        this.arrayEspecialidad.push({
          especialidad: this.especialidad[0],
          sesiones: this.sesiones,
          nombre: this.especialidad[1],
        });
        this.especialidad = "";
        this.sesiones = "";
      }
      // console.log(this.arrayEspecialidad);
    },

    selectEspecialidad() {
      var token = localStorage.getItem("token");
      axios
        .request({
          method: "get",
          baseURL: this.ip + "api/selectEspecialidad",
          headers: {
            Authorization: "Bearer " + token, //utilizacion de la variable que contiene el token
            "Content-Type": "application/json",
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.arrayEspecialidades = response.data.data;
          // console.log(this.arrayEspecialidades);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    verDetalle(row) {
      this.terapeutaPDF = "";
      this.$modal.show("modalNuevoPlanDetalle");
      var token = localStorage.getItem("token");
      var TraIde = row.TraIde;
      axios
        .request({
          method: "get",
          baseURL: this.ip + "api/detalle/" + TraIde,
          headers: {
            Authorization: "Bearer " + token, //utilizacion de la variable que contiene el token
            "Content-Type": "application/json",
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.arrayDetalle = response.data.data;
          this.fechaTratamiento = row.TraFec;
          this.cie10mostrar = row.TraCas;
          (this.descripcionTratamiento = row.TraDes),
            (this.fechaFinTratamiento = row.TraFecFin),
            (this.actividadFamiliar = row.TraActFam);
          this.logo = response.data.logo;

          this.terapeutaPDF = row.terapeuta;
          // console.log(this.response.data.data[0];
        })
        .catch(function (error) {});
    },
    tipoExamen() {
      this.cambiarLinkExamen();
      if (this.examen == 1) {
        // this.examenActivo = "Formato de evaluación terapia ocupacional";
        this.arrayActivo = this.arrayExamen;
      }
      if (this.examen == 2) {
        // this.examenActivo = "Formato de evaluación psicología niños";
        this.arrayActivo = this.arrayExamen2;
      }
      if (this.examen == 3) {
        // this.examenActivo = "Formato de evaluación fonoaudiología";
        this.arrayActivo = this.arrayExamen3;
      }
      if (this.examen == 4) {
        // this.examenActivo = "Formato de evaluación ";
        this.arrayActivo = this.arrayExamen4;
      }
      if (this.examen == 5) {
        // this.examenActivo = "Fisioterapia";
        this.arrayActivo = this.arrayExamen5;
      }
      if (this.examen == 6) {
        // this.examenActivo = "Fisioterapia";
        this.arrayActivo = this.arrayExamen6;
      }
      if (this.examen == 7) {
        // this.examenActivo = "Fisioterapia";
        this.arrayActivo = this.arrayExamen7;
      }
      if (this.examen == 8) {
        // this.examenActivo = "Fisioterapia";
        this.arrayActivo = this.arrayExamen8;
      }
      if (this.examen == 9) {
        // this.examenActivo = "Fisioterapia";
        this.arrayActivo = this.arrayExamen9;
      }
      if (this.examen == 10) {
        // this.examenActivo = "Fisioterapia";
        this.arrayActivo = this.arrayExamen10;
      }
      if (this.examen == 11) {
        // this.examenActivo = "Fisioterapia";
        this.arrayActivo = this.arrayExamen11;
      }
    },

    calcularFechaActual() {
      var mes;
      var fecha_hoy = new Date();

      var ahora_ano = fecha_hoy.getFullYear();
      var ahora_mes = fecha_hoy.getMonth() + 1;
      var ahora_dia = fecha_hoy.getDate();

      if (ahora_mes < 10 || ahora_dia < 10) {
        if (ahora_mes < 10) {
          ahora_mes = "0" + ahora_mes;
        }
        if (ahora_dia < 10) {
          ahora_dia = "0" + ahora_dia;
        }
        this.fechaDeConsulta = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaAntecedente = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaImpresion = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaResumen = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaTratamiento = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaVerificado = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      } else {
        this.fechaAntecedente = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaDeConsulta = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaImpresion = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaResumen = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaTratamiento = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaVerificado = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      }
    },
    calcularEdad() {
      if (this.Fecha_nacimiento != "") {
        var fechaNacimiento = this.Fecha_nacimiento;
        var values = fechaNacimiento.split("-");
        var dia = values[2];
        var mes = values[1];
        var ano = values[0];

        var fecha_hoy = new Date();
        var ahora_ano = fecha_hoy.getFullYear();
        var ahora_mes = fecha_hoy.getMonth() + 1;
        var ahora_dia = fecha_hoy.getDate();

        var fechaActual = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        // this.fechaIngreso = fechaActual;

        var edad = ahora_ano + 0 - ano;
        if (ahora_mes < mes) {
          edad--;
        }
        if (mes == ahora_mes && ahora_dia < dia) {
          edad--;
        }
        if (edad > 1900) {
          edad -= 1900;
        }

        // calculamos los meses
        var meses = 0;
        if (ahora_mes > mes) meses = ahora_mes - mes;
        if (ahora_mes < mes) meses = 12 - (mes - ahora_mes);
        if (ahora_mes == mes && dia > ahora_dia) meses = 11;

        // calculamos los dias
        var dias = 0;
        if (ahora_dia > dia) dias = ahora_dia - dia;
        if (ahora_dia < dia) {
          var ultimoDiaMes = new Date(ahora_ano, ahora_mes - 1, 0);
          var dias = ultimoDiaMes.getDate() - (dia - ahora_dia);
        }

        this.anos = edad;
        this.meses = meses;
        this.edad = this.anos + " años y " + this.meses + " meses";
      } else {
        this.anos = 0;
      }
      // this.calcularFechaActual();
    },
    e_realizados_to: function () {
      let url = this.ip + "api/To_fechas/" + this.PacIde;
      axios
        .get(url)
        .then((response) => {
          this.examenesRealizados = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    e_realizados_ps: function () {
      let url = this.ip + "api/ps_fechas/" + this.PacIde;
      axios
        .get(url)
        .then((response) => {
          this.examenesRealizadosPs = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    e_realizados_fonol: function () {
      let url = this.ip + "api/fonoL_fechas/" + this.PacIde;
      axios
        .get(url)
        .then((response) => {
          this.examenesRealizadosfonol = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    examenesRealizadosF: function () {
      this.e_realizados_ps();
      this.e_realizados_ps();
      this.e_realizados_fonol();
    },

    alerta() {
      let opcion = confirm(
        `¿desea continuar viendo la historia clinica de ${localStorage.getItem(
          "PacienteNombre"
        )}?`
      );
      if (opcion == true) {
        this.criterio = "PacNumDoc";
        this.busqueda = localStorage.getItem("PacienteHC");
        this.buscarPacientes();
      } else {
        localStorage.removeItem("PacienteHC");
        localStorage.removeItem("PacienteId");
        localStorage.removeItem("PacienteNombre");
      }
    },
    push(route) {
      this.$router.push(route);
    },
    validarDispositivo: function () {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        // console.log("Esto es un dispositivo móvil", navigator.userAgent);
        
      }else{
        this.push('historia')
      }
    },
  },

  mounted() {
    if (!localStorage.getItem("token")) {
      this.$router.push("/");
    } else {
      this.motivosM();
      this.calcularFechaActual();
      this.usuarioAvanza = localStorage.getItem("usuario");
      if (localStorage.getItem("PacienteHC")) {
        this.alerta();
      }
      this.validarDispositivo();
    }
  },
};
</script>
<style scoped>
.card {
  border-radius: 10px;
  box-shadow: 0 0 0 0;
}

.text-grey {
  color: grey;
}

.table-responsive {
  border: none;
  padding: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/Historia Clinica/historia-clinica-movil.vue